import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/login.vue'
import recovery from '../views/login/recovery.vue'
import register from '../views/login/register.vue'
import password from '../views/login/password.vue'
import active from '../views/login/activate.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/recuperar',
    name: 'recovery',
    component: recovery
  },
  {
    path: '/registro',
    name: 'register',
    component: register
  },
  {
    path: '/renovar',
    name: 'password',
    component: password
  },
  {
    path: '/activar',
    name: 'active',
    component: active
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/login/',
  routes
})

export default router
